export default "__VITE_ASSET__59036f83__"